import type { CreateCredentialRequest, CredentialOwner, SiteCredentialView, UpdateCredentialRequest } from '@/types/api';
import { apiRequest } from '@/api/client';

/** Where an owner's credentials live: a site's (ADR-0031) or a server's (ADR-0058). */
const base = (owner: CredentialOwner) => `/${owner.kind === 'site' ? 'sites' : 'nodes'}/${owner.id}/credentials`;

/** Credentials kept for a site or a server: listed without passwords, each password asked for on its own. */
export const credentialsApi = {
  list: (owner: CredentialOwner) => apiRequest<SiteCredentialView[]>(base(owner)),

  create: (owner: CredentialOwner, input: CreateCredentialRequest) => apiRequest<SiteCredentialView>(base(owner), { method: 'POST', body: input }),

  update: (owner: CredentialOwner, id: string, input: UpdateCredentialRequest) =>
    apiRequest<SiteCredentialView>(`${base(owner)}/${id}`, { method: 'PUT', body: input }),

  remove: (owner: CredentialOwner, id: string) => apiRequest<{ removed: boolean }>(`${base(owner)}/${id}`, { method: 'DELETE' }),

  reveal: (owner: CredentialOwner, id: string) => apiRequest<{ password: string }>(`${base(owner)}/${id}/reveal`, { method: 'POST' }),

  /** A one-time page that signs into the site's admin with this credential (ADR-0035). */
  signIn: (siteId: string, id: string) =>
    apiRequest<{ url: string }>(`/sites/${siteId}/credentials/${id}/sign-in`, { method: 'POST' }),
};
